exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".active[data-v-bbc6816a]{position:relative}.active span.text[data-v-bbc6816a]{font-weight:700;--tw-text-opacity:1;color:rgba(91,217,164,var(--tw-text-opacity))}.active span.count[data-v-bbc6816a],.active span.side-border[data-v-bbc6816a]{display:block}", ""]);

// exports
